export const CSS_VAR_ICON = '--icon-color';
export const CSS_VAR_TILE = '--tile-color';
export const CSS_VAR_THEMED_ICON = '--themed-icon-color';
export const CSS_VAR_THEMED_TEXT = '--themed-text-color';
